/**
 * Config: Classes
 * -----------------------------------------------------------------------------
 * Global configuration for Vue states and CSS classes.
 * - Add in alphabetical order.
 *
 */
export default {
  active: 'is-active',
  collapsed: 'is-collapsed',
  dark: 'is-dark',
  desktop: 'is-desktop',
  disabled: 'is-disabled',
  dragging: 'is-dragging',
  error: 'has-error',
  fixed: 'is-fixed',
  hidden: 'is-hidden',
  invisible: 'is-invisible',
  large: 'is-large',
  loading: 'is-loading',
  minimised: 'is-minimised',
  mobile: 'is-mobile',
  moved: 'is-moved',
  open: 'is-open',
  small: 'is-small',
  sticky: 'is-sticky',
  success: 'has-success',
  tabbable: 'is-tabbable',
  transparent: 'is-transparent',
  updating: 'is-updating',
  visible: 'is-visible',
}
